var map = {
	"./Angels.png": 1255,
	"./Astros.png": 1256,
	"./Athletics.png": 1257,
	"./Blue Jays.png": 1258,
	"./Braves.png": 1259,
	"./Brewers.png": 1260,
	"./Cardinals.png": 1261,
	"./Cubs.png": 1262,
	"./Dbacks.png": 1263,
	"./Diamondbacks.png": 1264,
	"./Dodgers.png": 1265,
	"./Giants.png": 1266,
	"./Guardians.png": 1267,
	"./Mariners.png": 1268,
	"./Marlins.png": 1269,
	"./Mets.png": 1270,
	"./Nationals.png": 1271,
	"./Orioles.png": 1272,
	"./Padres.png": 1273,
	"./Phillies.png": 1274,
	"./Pirates.png": 1275,
	"./Rangers.png": 1276,
	"./Rays.png": 1277,
	"./Red Sox.png": 1278,
	"./Reds.png": 1279,
	"./Rockies.png": 1280,
	"./Royals.png": 1281,
	"./Tigers.png": 1282,
	"./Twins.png": 1283,
	"./White Sox.png": 1284,
	"./Yankees.png": 1285
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 333;